module.exports = __webpack_public_path__ + "img/chuli_popup.ead8d32f.png";